import { t } from "@lingui/macro"
import { IconType } from "@src/config/icons"

export const CATEGORY_IDS = [
  "communities",
  "projects",
  "applications",
  "surveys",
  "coaching",
] as const

export type Category = (typeof CATEGORY_IDS)[number]

export type CategoryItem = {
  id: string
  label: string
  icon: IconType
  iconUrl?: string | null
}

export const getStaticCategories = (): CategoryItem[] => [
  {
    id: "communities",
    label: t({ id: "communities", message: "Communities" }),
    icon: "group",
  },
  {
    id: "projects",
    label: t({ id: "projects", message: "{101}" }),
    icon: "rocket_launch",
  },
  {
    id: "applications",
    label: t({ id: "applications", message: "Applications" }),
    icon: "bookmarks",
  },
  {
    id: "surveys",
    label: t({ id: "surveys", message: "Surveys" }),
    icon: "assignment",
  },
  {
    id: "coaching",
    label: t({ id: "coaching", message: "Coaching" }),
    icon: "live_help",
  },
]

export const getCategories = (
  dynamicCategories: Array<{ name: string; iconUrl?: string | null }> = [],
): CategoryItem[] => [
  ...getStaticCategories(),
  ...dynamicCategories.map(({ name, iconUrl }) => ({
    id: name,
    label: name,
    icon: "rocket_launch" as IconType,
    iconUrl: iconUrl ?? null,
  })),
]
